import React from 'react';

import {
    Card,
    CardHeader,
    IconButton,
    CardContent,
    CardActions,
    Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import { TextFilter } from './filters/Text';
import { SelectFilter } from './filters/Select';
import { BooleanFilter } from './filters/Boolean';

const useStyles = makeStyles(theme => ({
    card: {
        minWidth: 275,
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column-reverse',
    },
    actions: {
        float: 'right',
    },
}));

const filterMapping = {
    text: TextFilter,
    select: SelectFilter,
    boolean: BooleanFilter,
};

const getFilter = (filterType = 'text') => {
    return filterMapping[filterType];
};

const MTableFilterInput = React.forwardRef(
    ({ onClose, onChange, value, onSubmit, filter = {}, data = [] }, ref) => {
        const classes = useStyles();
        const Filter = getFilter(filter.filterType);

        return (
            <Card ref={ref} className={classes.card}>
                <CardHeader
                    action={
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                    title={filter && filter.title}
                />
                <CardContent className={classes.cardContent}>
                    <Filter
                        onChange={onChange}
                        onSubmit={onSubmit}
                        value={value}
                        filter={filter}
                        data={data}
                    />
                </CardContent>
                <CardActions className={classes.actions}>
                    <Button size="small" onClick={onSubmit}>
                        Apply
                    </Button>
                </CardActions>
            </Card>
        );
    }
);

export { MTableFilterInput };
